import { useRef, useEffect, useState } from 'react';

/**
 * Ada robot icon — Lucide Bot with eyes that follow the mouse cursor.
 * animated=false for static eyes. working=true for spinning antenna.
 */
export const AdaIcon = ({ size = 20, animated = true, working = false }: { size?: number; animated?: boolean; working?: boolean }) => {
  const ref = useRef<SVGSVGElement>(null);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (!animated || working) return;
    let rafId = 0;
    const handleMouseMove = (e: MouseEvent) => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        if (!ref.current) return;
        const rect = ref.current.getBoundingClientRect();
        const cx = rect.left + rect.width / 2;
        const cy = rect.top + rect.height / 2;
        const dx = e.clientX - cx;
        const dy = e.clientY - cy;
        const dist = Math.sqrt(dx * dx + dy * dy);
        const max = 1;
        const scale = Math.min(max / Math.max(dist, 1), max / 100);
        setOffset({ x: dx * scale, y: dy * scale });
      });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      cancelAnimationFrame(rafId);
    };
  }, [animated, working]);

  const ex = (animated && !working) ? offset.x : 0;
  const ey = (animated && !working) ? offset.y : 0;

  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Antenna - arm spins around the stick when working */}
      {working ? (
        <>
          <path d="M12 8V4" />
          <path d="M12 4H8">
            <animate
              attributeName="d"
              values="M12 4H8;M12 4H12;M12 4H16;M12 4H12;M12 4H8"
              dur="0.8s"
              repeatCount="indefinite"
            />
          </path>
        </>
      ) : (
        <path d="M12 8V4H8" />
      )}
      <rect width="16" height="12" x="4" y="8" rx="2" />
      <path d="M2 14h2" />
      <path d="M20 14h2" />
      <path d={`M${9 + ex} ${13 + ey}v2`} />
      <path d={`M${15 + ex} ${13 + ey}v2`} />
    </svg>
  );
};
